import { Component, EventEmitter, Output } from '@angular/core';
import { MetricGroupDataType } from "../metric-group-crud-helper.service";
import { SharedComponentsModule } from "../../../../shared/module/shared-components.module";

@Component({
  selector: 'app-kpi-metric-group-data-type-selector',
  standalone: true,
  imports: [
    SharedComponentsModule,
  ],
  templateUrl: './kpi-metric-group-data-type-selector.component.html',
  styleUrl: './kpi-metric-group-data-type-selector.component.scss',
})
export class KpiMetricGroupDataTypeSelectorComponent {
  @Output() dataTypeEmitter = new EventEmitter<MetricGroupDataType>();

  readonly dataTypes: DataType[] = [
    {
      header: 'Numbers with balances',
      text: 'For ARR, Customers and other KPIs that require beginning & ending balances',
      img: 'assets/screenshot/kpi/kpi-metric-group-data-type-numbers.png',
      type: 'Numbers with balances',
      chips: [
        {
          name: 'Sum (previous period)',
          icon: 'sum.svg',
        },
        {
          name: 'Number',
          icon: '123.svg',
        },
        {
          name: 'Sum (current period)',
          icon: 'sum.svg',
        },
      ],
    },
    {
      header: 'Any metrics',
      text: 'Text, percentage, date,  document & number',
      img: 'assets/screenshot/kpi/kpi-metric-group-data-type-any.png',
      type: 'Any metrics',
      chips: [
        {
          name: 'Document',
          icon: 'copy-outline.svg',
        },
        {
          name: 'Number',
          icon: '123.svg',
        },
        {
          name: 'Text',
          icon: 'abc.svg',
        },
        {
          name: 'Percent',
          icon: 'percent.svg',
        },
        {
          name: 'Date',
          icon: 'calendar.svg',
        },
      ],
    },
  ];

  emit(type: MetricGroupDataType): void {
    this.dataTypeEmitter.emit(type);
  }
}

interface DataType {
  header: string;
  text: string;
  chips: MetricType[]
  img: string;
  type: MetricGroupDataType;
}

interface MetricType {
  name: string;
  icon: string;
}
